import { render, staticRenderFns } from "./StartDate.vue?vue&type=template&id=388c0c0f&"
import script from "./StartDate.vue?vue&type=script&lang=js&"
export * from "./StartDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports